import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Rocket, Download, AlertCircle, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function VideoPublic() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, error: "", meta: null });
  const [playFailed, setPlayFailed] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API}/public/video/${token}`);
        if (r.status === 404) { setState({ loading: false, error: "Dieser Share-Link ist nicht aktiv oder abgelaufen.", meta: null }); return; }
        if (!r.ok) { setState({ loading: false, error: "Video konnte nicht geladen werden.", meta: null }); return; }
        const meta = await r.json();
        setState({ loading: false, error: "", meta });
      } catch { setState({ loading: false, error: "Video konnte nicht geladen werden.", meta: null }); }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0b0f17] text-slate-100 flex flex-col">
      <header className="px-6 py-5 flex items-center gap-2 border-b border-white/5" data-testid="public-video-brand">
        <div className="h-9 w-9 rounded-xl bg-emerald-500/15 text-emerald-400 grid place-items-center">
          <Rocket className="h-5 w-5" />
        </div>
        <div className="font-bold tracking-tight">Marketing Rocket</div>
      </header>

      <main className="flex-1 max-w-3xl w-full mx-auto px-6 py-10">
        {state.loading && (
          <div className="text-sm text-slate-400 flex items-center gap-2" data-testid="public-video-loading">
            <Loader2 className="h-4 w-4 animate-spin" /> Lade Video…
          </div>
        )}
        {state.error && (
          <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-6 text-sm text-amber-100 flex items-start gap-3" data-testid="public-video-error">
            <AlertCircle className="h-5 w-5 shrink-0 mt-0.5" />
            <div>
              <div className="font-semibold mb-1">{state.error}</div>
              <div className="text-xs text-amber-200/80">
                Falls du den Link erhalten hast, bitte die Absenderin um einen neuen.
              </div>
            </div>
          </div>
        )}
        {state.meta && (
          <>
            <h1 className="text-2xl font-extrabold tracking-tight mb-5" data-testid="public-video-title">{state.meta.title}</h1>
            {playFailed ? (
              <div className="rounded border border-amber-500/30 bg-amber-500/5 p-4 text-sm text-amber-100" data-testid="public-video-fallback">
                <div className="font-semibold mb-1">Video konnte in deinem Browser nicht abgespielt werden.</div>
                <div className="text-xs text-amber-200/80 mb-3">Die MP4-Datei ist aber unversehrt — du kannst sie jederzeit herunterladen.</div>
                <a href={API + state.meta.download_url} download className="inline-flex items-center gap-1 text-emerald-300 hover:text-emerald-200 text-xs" data-testid="public-video-fallback-download">
                  <Download className="h-3.5 w-3.5" /> Video herunterladen
                </a>
              </div>
            ) : (
              <video src={API + state.meta.stream_url} controls autoPlay={false}
                onError={() => setPlayFailed(true)}
                className="w-full max-h-[75vh] bg-black rounded-xl border border-white/10"
                data-testid="public-video-player" />
            )}
            <div className="mt-4 flex items-center justify-between text-xs text-slate-500">
              <div>Veröffentlicht am {new Date(state.meta.created_at).toLocaleDateString("de-DE")}</div>
              <a href={API + state.meta.download_url} download className="inline-flex items-center gap-1 text-emerald-300 hover:text-emerald-200" data-testid="public-video-download">
                <Download className="h-3.5 w-3.5" /> MP4
              </a>
            </div>
          </>
        )}
      </main>

      <footer className="px-6 py-5 border-t border-white/5 text-xs text-slate-500 flex items-center justify-between" data-testid="public-video-footer">
        <div className="flex items-center gap-1.5">
          <span>Erstellt mit</span>
          <span className="font-semibold text-slate-400">Marketing Rocket</span>
          <Rocket className="h-3 w-3 text-emerald-400" />
        </div>
      </footer>
    </div>
  );
}
